import { postWithAuth } from "utilities/api";

export async function login(azureAccessToken: string) {
  var loginURL = window.env.baseURL + "auth/login";
  return postWithAuth(loginURL, azureAccessToken).then((response) => {
    return response;
  });
}
